import React from 'react'
import styled from 'styled-components'

interface IContainerProps {
  alignSelf?: React.CSSProperties['alignSelf']
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  align-self: ${props => props.alignSelf};
  gap: 8px;

  width: fit-content;
  max-width: 80%;
`

export const Avatar = styled.div`
  width: ${({ theme }) => theme.zds.size.variant210};
  height: ${({ theme }) => theme.zds.size.variant210};
  border-radius: 100%;
  background: linear-gradient(225deg, #061d38 14.64%, #1774de 85.36%);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: #fff;
  }
`

export const Content = styled.div`
  min-width: 20px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 8px 16px 8px 16px;
  border-radius: 16px 16px 16px 0px;
  background: #fff;
  box-shadow: 0px 0px 16px 0px #2b3d4514;

  ${({ theme }) => theme.zds.typography.body300};
`

export const FromLeft = styled.div`
  display: flex;
  min-width: 20px;
  flex-direction: column;
  gap: 0.5rem;
  padding: 8px 16px 8px 16px;
  border-radius: 16px 16px 16px 0px;
  background: #fff;
  box-shadow: 0px 0px 16px 0px #2b3d4514;

  ${({ theme }) => theme.zds.typography.body300};
`

export const FromRight = styled.div`
  display: flex;
  max-width: 400px;
  min-width: 20px;
  flex-direction: column;
  gap: 0.5rem;
  padding: 8px 16px 8px 16px;
  border-radius: 16px 16px 0px 16px;
  background: ${({ theme }) => theme.zds.colors.blue400};
  box-shadow: 0px 0px 16px 0px #2b3d4514;

  white-space: pre-wrap;

  ${({ theme }) => theme.zds.typography.body300};
  color: #fff;
`

export const Footer = styled.div`
  display: flex;
`
